// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".items{background:#fff;border-radius:.5rem;box-shadow:0 0 0 1px rgba(0,0,0,.05),0 10px 20px rgba(0,0,0,.1);color:rgba(0,0,0,.8);font-size:.9rem;overflow:hidden;padding:.2rem;position:relative}.variable{background:transparent;border:1px solid transparent;border-radius:.4rem;margin:0;padding:.2rem .4rem;text-align:left;width:100%}.variable.is-selected{border-color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
